import { calculateStrandingPoint } from "functions/Modernization";

import type { CrremPathwayScatterSeries } from "../model/types";

type StrandingRow = {
  crrem?: number;
  current?: number;
  modernized?: number;
  year?: number;
};

const toScatterPoints = (points: number[][]) =>
  points
    .filter((point) => typeof point[0] === "number" && typeof point[1] === "number")
    .map((point) => ({ x: point[0], y: point[1] }));

export const buildStrandingScatterSeries = (data: StrandingRow[]): CrremPathwayScatterSeries[] => {
  const enhancedData = data.map((row) => {
    if (row.crrem !== undefined) return row;
    const yearData = data.find((item) => item.year === row.year && item.crrem !== undefined);
    return yearData ? { ...row, crrem: yearData.crrem } : row;
  });
  const series: CrremPathwayScatterSeries[] = [];
  const current = toScatterPoints(calculateStrandingPoint(data, "current"));
  const modernized = toScatterPoints(calculateStrandingPoint(enhancedData, "modernized"));
  if (current.length) series.push({ name: "Stranding Event", points: current });
  if (modernized.length) series.push({ name: "Stranding Event", points: modernized });
  return series;
};
